<template>
  <b-container id="wrapper" class="bv-example-row">
    <b-row>
      <b-col id="logo" align="center" cols="12" class="layout-item">
        <LogoItem></LogoItem>
      </b-col>
      <b-col cols="12" md="6" lg="4" class="layout-item">
        <MessageForm></MessageForm>
      </b-col>
      <b-col cols="12" md="6" lg="8" class="layout-item-messages">
        <MessageList :messages="messages"></MessageList>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import MessageForm from '@/components/MessageForm.vue'
  import MessageList from '@/components/MessageList.vue'
  import {getMessagesCollection, mapDocuments} from '@/services/messages'
  import LogoItem from "../components/LogoItem";

  export default {
    name: 'home',
    components: {
      LogoItem,
      MessageForm,
      MessageList
    },
    data: () => ({
      messages: []
    }),
    unsubscribeFromMessages: null,
    mounted() {
      this.unsubscribeFromMessages = getMessagesCollection()
        .orderBy('createdAt', 'desc')
        .onSnapshot((snapshot) => {
          this.messages = mapDocuments(snapshot)
        })
    },
    beforeDestroy() {
      this.unsubscribeFromMessages()
    }
  }
</script>

<style>
  .layout-item {
    margin-top: 15px;
    margin-bottom: 25px;
  }

</style>
